import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2, Wallet } from "lucide-react";
import { apiFile, errText, fetchReceipts, fetchReceivables, makeReceipt, ron } from "@/lib/bf";
import { DemoTag } from "./BFStockTotal";

const STATE = { restanta: "restantă", scadenta: "scadentă în 7 zile", in_termen: "în termen" };
const dmy = (d) => d.split("-").reverse().join(".");

const PayForm = ({ g, onDone }) => {
  const [amt, setAmt] = useState(String(g.balance));
  const [busy, setBusy] = useState(false);
  const key = `${g.lead}-${g.firm}`;
  const go = () => {
    const amount = Number(amt.replace(",", "."));
    if (!(amount > 0)) return toast.error("Scrie suma încasată");
    setBusy(true);
    makeReceipt({ lead: g.lead, firm: g.firm, amount }).then((r) => { toast.success(`Chitanța ${r.no} emisă · sold rămas ${ron(r.balance)}`, { duration: 12000, action: { label: "Deschide PDF", onClick: () => window.open(apiFile(r.pdf), "_blank") } }); onDone(); })
      .catch((e) => toast.error(errText(e, "Nu am putut emite chitanța"))).finally(() => setBusy(false));
  };
  return (
    <div className="bf-pay" data-testid={`bf-pay-${key}`}>
      <input inputMode="decimal" value={amt} onChange={(e) => setAmt(e.target.value)} data-testid={`bf-pay-amount-${key}`} />
      <button type="button" className="st-btn st-btn--light" onClick={go} disabled={busy} data-testid={`bf-pay-submit-${key}`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Wallet size={14} />} Emite chitanța
      </button>
    </div>
  );
};

export default function BFReceivables({ admin = false }) {
  const [rows, setRows] = useState(null);
  const [recs, setRecs] = useState([]);
  const [open, setOpen] = useState("");
  const load = useCallback(() => {
    fetchReceivables().then(setRows).catch(() => setRows([]));
    fetchReceipts().then(setRecs).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const groups = Object.values((rows || []).reduce((a, i) => {
    const k = `${i.lead}-${i.firm}`;
    a[k] = a[k] || { lead: i.lead, firm: i.firm, firm_name: i.firm_name, salon: i.salon, balance: 0, invs: [] };
    a[k].balance = Math.round((a[k].balance + i.balance) * 100) / 100;
    a[k].invs.push(i);
    return a;
  }, {}));
  const total = groups.reduce((s, g) => s + g.balance, 0);
  return (
    <section className="invite-box" data-testid="bf-receivables">
      <h3><Wallet size={18} /> {admin ? "Facturi de încasat" : "De încasat de la saloanele tale"} · {ron(total)} <DemoTag /></h3>
      <p className="st-hint">Emite chitanța când încasezi. Ajunge în NeoManager și scade imediat din soldul clientului.</p>
      {!rows && <p className="st-hint">Se încarcă…</p>}
      {rows && !groups.length && <p className="st-hint" data-testid="bf-receivables-empty">Nicio factură de încasat.</p>}
      <ul className="bf-recv">
        {groups.map((g) => {
          const key = `${g.lead}-${g.firm}`;
          return (
            <li key={key} data-testid={`bf-recv-${key}`}>
              <header>
                <div><b>{g.salon || "Salon"}</b><small>{g.firm_name}</small></div>
                <strong>{ron(g.balance)}</strong>
                <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(open === key ? "" : key)} data-testid={`bf-recv-pay-${key}`}>Încasează</button>
              </header>
              {g.invs.map((i) => (
                <div key={i.id} className="bf-recv-inv" data-testid={`bf-recv-inv-${i.no}`}>
                  <span>{i.no} · {dmy(i.date)}</span>
                  <span>scadență {dmy(i.due)} <em className={`bf-due is-${i.state}`}>{STATE[i.state]}</em></span>
                  <b>{ron(i.balance)}{i.paid > 0 && <small> din {ron(i.total)}</small>}</b>
                </div>
              ))}
              {open === key && <PayForm g={g} onDone={() => { setOpen(""); load(); }} />}
            </li>
          );
        })}
      </ul>
      {recs.length > 0 && <>
        <h4 className="bf-recv-h4">Chitanțe emise ({recs.length})</h4>
        <ul className="bfa-leads">
          {recs.slice(0, 30).map((c) => (
            <li key={c.id} data-testid={`bf-receipt-${c.no}`}>
              <div><b>{c.no} · {c.salon}</b><span>{dmy(c.date)} · {c.firm_name} · NeoManager {c.neo_no}{admin ? ` · ${c.agent_name}` : ""}</span></div>
              <div className="interested-actions"><span className="bfa-pf-total">{ron(c.amount)}</span>
                <a className="st-btn st-btn--ghost" href={apiFile(c.pdf)} target="_blank" rel="noopener noreferrer" data-testid={`bf-receipt-pdf-${c.no}`}><FileText size={14} /> PDF</a></div>
            </li>
          ))}
        </ul>
      </>}
    </section>
  );
}
